var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useRetrieveLeague } from "../api/LeagueApiProvider";
import { useAddVenueToLeague, useListLeagueHomeVenues, } from "../api/LeagueVenueApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { safeReturnTo } from "../utils/safeReturnTo";
import { useNumericParams } from "../utils/useNumericParams";
import { AddVenueToEntity } from "../venues/AddVenueToEntity";
export var AddVenueToLeague = function () {
    var navigate = useNavigate();
    var _a = __read(useSearchParams(), 1), searchParams = _a[0];
    var leagueId = useNumericParams().id;
    var returnTo = searchParams.get("returnTo");
    var _b = useRetrieveLeague({
        id: leagueId,
    }), league = _b.data, leagueLoading = _b.isLoading;
    var existingVenues = useListLeagueHomeVenues({
        leagueId: leagueId,
        enabled: !!leagueId,
    }).data;
    var addVenueMutation = useAddVenueToLeague({
        leagueId: leagueId,
        onSuccess: function () {
            navigate(safeReturnTo(returnTo, "/leagues/".concat(leagueId, "/venues/")));
        },
        onError: function () { },
    });
    var handleAdd = function (venueId, fromDate) {
        if (!leagueId)
            return;
        addVenueMutation.mutate(__assign({ league: leagueId, venue: venueId }, (fromDate && { fromDate: fromDate })));
    };
    if (leagueLoading) {
        return _jsx(Loading, {});
    }
    if (!league || !leagueId) {
        return _jsx(ErrorView, {});
    }
    // Get IDs of active venues to filter from search results
    var existingVenueIds = (existingVenues === null || existingVenues === void 0 ? void 0 : existingVenues.filter(function (v) { return v.isActive; }).map(function (v) { return v.venue.id; })) || [];
    return (_jsx(AddVenueToEntity, { entityName: "league", entityDisplayName: league.name, entityId: leagueId, cancelUrl: "/leagues/".concat(leagueId, "/venues/"), existingVenueIds: existingVenueIds, addMutation: addVenueMutation, onAdd: handleAdd }));
};
